import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';
import flespiDeviceService from '../../../../services/FlespiDeviceService';
import toast from 'react-hot-toast';
import ReactSelect from 'react-select';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  makeStyles,
  Divider,
  AccordionActions,
  Button,
  TextField,
  InputAdornment
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SettingsIcon from '@material-ui/icons/Settings';
import SendIcon from '@material-ui/icons/Send';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: '#757575',
    fontWeight: '700'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.text.secondary
  },
  accordionSummaryDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  settingsDiv: {
    marginRight: '12px'
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column'
  },
  accordionDetailsItem: {
    marginBottom: '1rem'
  }
}));

const hemisphereOptions = [
  { value: 'eastern', label: 'Eastern', id: 0 },
  { value: 'western', label: 'Western', id: 1 }
];

const halfTimezoneOptions = [
  { value: 0, label: '0', id: 0 },
  { value: 15, label: '15', id: 1 },
  { value: 30, label: '30', id: 0 },
  { value: 45, label: '45', id: 1 }
];

const ConfigurationTab = ({ selectedTabSettings }) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm({
    defaultValues: {
      half_tz: selectedTabSettings[0]?.current?.half_tz,
      hemisphere: selectedTabSettings[0]?.current?.hemisphere,
      time_zone: selectedTabSettings[0]?.current?.time_zone
    }
  });

  const handleTimezoneSMSParams = (data) => {
    // eslint-disable-next-line no-console, no-undef
    console.log('data', data);
    setLoading(true);

    const timezoneParamsPayload = {
      deviceId: selectedTabSettings[0]?.device_id,
      settSelector: 'timezone_sms',
      properties: {
        half_tz: data.half_tz,
        hemisphere: data.hemisphere,
        time_zone: data.time_zone
      }
    };

    // eslint-disable-next-line no-console, no-undef
    console.log('timezoneParamsPayload', timezoneParamsPayload);

    flespiDeviceService
      .updateFlespiDeviceSetting(timezoneParamsPayload)
      .then((data) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('data is:', data);
        toast.success('Successfully updated timezone sms setting');
      })
      .catch((error) => {
        // eslint-disable-next-line no-console, no-undef
        console.log('error', error?.time_zone?.data?.message);
        toast.error(error?.time_zone?.data?.message || 'Unable to update timezone sms settings');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // eslint-disable-next-line no-console, no-undef
  console.log('errors are,', errors);

  return (
    <div style={{ marginBottom: '1rem' }}>
      <form onSubmit={handleSubmit(handleTimezoneSMSParams)}>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className={classes.accordionSummary}
          >
            <div className={classes.accordionSummaryDiv}>
              <div className={classes.settingsDiv}>
                <SettingsIcon />
              </div>

              <div>
                <Typography className={classes.heading}>SMS event Time Zone</Typography>
              </div>
            </div>
          </AccordionSummary>

          <Divider />

          <AccordionDetails className={classes.accordionDetails}>
            <Typography style={{ color: '#9e9e9e', marginBottom: '10px' }}>SMS event Time Zone</Typography>

            <div className={classes.accordionDetailsItem}>
              <Controller
                label="Hemisphere"
                control={control}
                name="hemisphere"
                render={({ field }) => (
                  <ReactSelect
                    className="basic-single"
                    classNamePrefix="select"
                    value={hemisphereOptions.find((option) => option.id === field.value)}
                    isSearchable={true}
                    name="hemisphere"
                    options={hemisphereOptions}
                    onChange={(selectedOption) => field.onChange(selectedOption ? selectedOption.id : null)}
                    // eslint-disable-next-line no-undef
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 2 }) }}
                  />
                )}
              />
            </div>

            <div className={classes.accordionDetailsItem}>
              <Controller
                name="half_tz"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Timezone"
                    size="small"
                    type="number"
                    fullWidth
                    variant="outlined"
                    {...field}
                    error={!!errors.half_tz}
                    helperText={errors.half_tz?.message}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Hours</InputAdornment>
                    }}
                  />
                )}
              />
            </div>

            <div>
              <Controller
                label="Half Time Zone"
                control={control}
                name="time_zone"
                render={({ field }) => (
                  <ReactSelect
                    className="basic-single"
                    classNamePrefix="select"
                    value={halfTimezoneOptions.find((option) => option.id === field.value)}
                    isSearchable={true}
                    name="time_zone"
                    options={halfTimezoneOptions}
                    onChange={(selectedOption) => field.onChange(selectedOption ? selectedOption.id : null)}
                  />
                )}
              />
            </div>
          </AccordionDetails>

          <AccordionActions style={{ cursor: 'pointer' }}>
            <Button
              size="small"
              color="primary"
              title="Changes will apply to the device"
              type="submit"
              disabled={loading}
            >
              <SendIcon />
            </Button>
          </AccordionActions>
        </Accordion>
      </form>
    </div>
  );
};

export default ConfigurationTab;

ConfigurationTab.propTypes = {
  selectedTabSettings: PropTypes.array
};
